import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '..';
import service from '../../services/api.service';
import { plainToClass } from 'class-transformer';
import { getTenantId } from '@/store/helper';
import { HeartBeatModel } from '../models/security/heartbeat';
let SecurityModule = /** @class */ (() => {
    var _a, _b;
    let SecurityModule = class SecurityModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.heartBeat = null;
            this.apiNode = 'security';
        }
        async HeartBeat() {
            var url = `${getTenantId()}/${this.apiNode}/heartbeat`;
            let { data } = await service.get(url);
            if (data) {
                this.SetHeartBeat(plainToClass(HeartBeatModel, data.heartBeat));
                return data.heartBeat;
            }
        }
        SetHeartBeat(heartBeat) {
            console.log('This heart bet at: ' + heartBeat.recentActivityTime);
            this.heartBeat = heartBeat;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], SecurityModule.prototype, "HeartBeat", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof HeartBeatModel !== "undefined" && HeartBeatModel) === "function" ? _b : Object]),
        __metadata("design:returntype", void 0)
    ], SecurityModule.prototype, "SetHeartBeat", null);
    SecurityModule = __decorate([
        Module({ dynamic: true, store: store, name: 'security', namespaced: true })
    ], SecurityModule);
    return SecurityModule;
})();
export const SecurityProviderModule = getModule(SecurityModule);
